/*************************************************/
/* TABS COMPONENT                                */
/*************************************************/
export function tabs() {
    const init = () => {
        const accordionItems = document.querySelectorAll('.tabs-component__header-nav-item button');

        accordionItems.forEach((item, index) => {
            item.addEventListener('click', () => handleAccordionItemClick(item, index));
        });
    }

    const handleAccordionItemClick = (clickedButton, index) => {
        const allAccordionItems = document.querySelectorAll('.tabs-component__container .accordion__item');
        
        allAccordionItems.forEach((accordionItem) => {
            accordionItem.classList.remove('accordion__item--active');
        });

        const allButtons = document.querySelectorAll('.tabs-component__header-nav-item button');
        
        allButtons.forEach((button) => {
            button.classList.remove('active-title');
        });

        const clickedAccordionItem = document.querySelector(`.tabs-component__container .accordion__item[data-accordion-item-index="${index}"]`);
        
        if (clickedAccordionItem) {
            clickedAccordionItem.classList.add('accordion__item--active');

            clickedButton.classList.add('active-title');
        }
    }

    init();
}


